module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Light.d8ff13a.woff2";